import { useEffect, useMemo, useState } from "react";
import { industriesFromJobs, orderIndustries, keepOrder, resolveIndustry, industryTabs, buildAuditsAddress } from "../../core/data/auditsPage";

// Which industries get a tab and which one is selected.
// - Before the roll-up arrives, tabs are ordered by Snapshot count; when it
//   arrives (or fails) the order is set once, by searches, and then kept.
// - requested: the industry picked (or named in the address). If this account
//   doesn't have it, the first tab is used, with no error.
// - The selected industry is written to the page address (?industry=...).
export default function useIndustrySelection(jobs, rollupState, requested) {
  const industries = useMemo(() => industriesFromJobs(jobs), [jobs]);
  const settled = rollupState.status === "ready" || rollupState.status === "error";
  const [frozen, setFrozen] = useState(null);

  useEffect(() => {
    if (settled && !frozen && industries.length > 0) setFrozen(orderIndustries(industries, rollupState.rollup));
  }, [settled, frozen, industries, rollupState.rollup]);

  const fresh = orderIndustries(industries, settled ? rollupState.rollup : null);
  const order = keepOrder(frozen, fresh);
  const selected = resolveIndustry(requested, order);
  const { tabs, more } = industryTabs(order, industries, selected);

  useEffect(() => {
    if (!selected) return;
    window.history.replaceState(null, "", `${window.location.pathname}${buildAuditsAddress(selected)}`);
  }, [selected]);

  const byKey = new Map(industries.map(i => [i.key, i]));
  return { byKey, selected, current: byKey.get(selected) || null, tabs, more };
}
